export default {
  set_token(state, data) {
    state.userInfo = data
  },
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setUserInfo1(state, data) {
    // 榜单
    state.userInfo1 = data
  }
}
